import React from "react";
import { Route, Redirect } from "react-router-dom";
import apis from '../api';
import authenticationService from '../services/authentication.service';
import VerificationPage from "../views/Verification/VerificationPage/VerificationPage";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PrivateRoute
Description : Pagina de PrivateRoute para permitir acceso a las paginas si el loguin esta correcto.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de PrivateRoute.
================================================================================ */
export function PrivateRoute({ component, ...options }) {

    const autenticado = authenticationService.getAuthUser();
    //console.log(autenticado);
    //localStorage.removeItem("type")

    // if (autenticado.token && autenticado.type === "ADMIN" && autenticado.enabled === "N") {
    //     window.location.href = "/Verification";
    //     // return <Route exact path='/Verification' {...options} component={VerificationPage} />
    // }

    return (
        autenticado.token && autenticado.type === "ADMIN"
            ? <Route {...options} component={component} />
            : (autenticado.token && autenticado.type === "CLIENT" && (options.location.pathname === "/Certificate" || options.location.pathname === "/Retefuente" ||
                options.location.pathname === "/Voucher" || options.location.pathname === "/CIRVoucher" || options.location.pathname === "/PasswordManagement") ?
                <Route path={options.location.pathname} {...options} component={component} /> : <Redirect to="/Login" />)
    )
};


export default PrivateRoute;
